import apis from "../../core/apis.js";

class InvoiceItemResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.invoiceItem).get(options);
  }

  get(id) {
    return this.$resource(apis.invoiceItem + id).get();
  }

  search(search = "") {
    return this.$resource(apis.invoiceItem).get({ search });
  }

  post(item) {
    return this.$resource(apis.invoiceItem).save(item);
  }

  activate(id, data) {
    return this.$resource(apis.invoiceItem + id + "/activate").save(data);
  }

  deactivate(id, data) {
    return this.$resource(apis.invoiceItem + id + "/deactivate").save(data);
  }

  addNote(id, item) {
    return this.$resource(apis.invoiceItem + id + "/add_note").save(item);
  }

  getTypes(data) {
    return this.$resource(apis.invoiceItem + "types").get(data);
  }

  resolve(data) {
    return this.$resource(
      apis.invoiceItem + "update_cash_collection_status"
    ).save(data);
  }
}

export default InvoiceItemResource;



// WEBPACK FOOTER //
// ./src/resources/invoiceItem/invoiceItem.resource.js